import React, { useContext, useEffect, useState } from "react";
import AppContext from "../AppContext";
import { MDBContainer } from "mdb-react-ui-kit";

import CarouselComponent from "../components/carousel/CarouselComponent";

export default function GaleryPage() {
  const context = useContext(AppContext);
  const [albums, setAlbums] = useState([]);
  const [images, setImages] = useState([]);
  const [currentLine, setCurrentLine] = useState();

  useEffect(() => {
    onGetAlbums();
  }, []);

  const onGetAlbums = () => {
    context.interAxios.get("/album", function (response) {
      console.log(response.data);
      setAlbums(response.data);
    });
  };

  const onGetImagesFromAlbum = (id, n) => {
    setCurrentLine(n);
    context.interAxios.get("/album/" + id, function (response) {
      console.log(response.data.media);
      setImages(response.data.media);
    });
  };

  return (
    <MDBContainer>
      {albums && (
        <div className="album-list">
          {albums.map((k, n) => {
            return (
              <div key={n}>
                <a
                  className={n === currentLine ? "year-link active" : "year-link"}
                  onClick={() => onGetImagesFromAlbum(k.id, n)}
                >
                  {k.title}
                </a>
                {images.length > 0 && n === currentLine && <CarouselComponent fotoList={images} />}
              </div>
            );
          })}
        </div>
      )}
    </MDBContainer>
  );
}
